import React, { useState, useEffect } from 'react';
import { useHistory, useParams, Link } from 'react-router-dom';
import SuperadminLayout from './SuperadminLayout';
import axios from '../../axios/axiosconf';
import './SuperadminStyles.css';

const EditarPlantillaAdmin = () => {
    const history = useHistory();
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);
    
    const [nombre, setNombre] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [especialidad, setEspecialidad] = useState('');
    const [estado, setEstado] = useState(1);
    const [secciones, setSecciones] = useState([]);

    useEffect(() => {
        const token = localStorage.getItem('superadmin_token');
        const user = localStorage.getItem('superadmin_user');

        if (!token || !user) {
            history.push('/superadmin/login');
            return;
        }

        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        cargarPlantilla();
    }, [history, id]);

    const cargarPlantilla = () => {
        setLoading(true);
        
        axios.get(`/superadmin/plantillas-admin/${id}`)
            .then(response => {
                const plantilla = response.data;
                setNombre(plantilla.nombre);
                setDescripcion(plantilla.descripcion || '');
                setEspecialidad(plantilla.especialidad || '');
                setEstado(plantilla.estado);
                
                let estructura = plantilla.estructura;
                
                if (typeof estructura === 'string') {
                    try {
                        estructura = JSON.parse(estructura);
                    } catch (e) {
                        console.error('Error parsing estructura:', e);
                        estructura = null;
                    }
                }
                
                if (estructura && estructura.secciones && Array.isArray(estructura.secciones)) {
                    setSecciones(estructura.secciones);
                } else {
                    setSecciones([{
                        id: 'seccion_1',
                        titulo: 'Sección 1',
                        campos: []
                    }]);
                }
                
                setLoading(false);
            })
            .catch(error => {
                console.error(error);
                alert('Error al cargar plantilla: ' + (error.response?.data?.message || error.message));
                setLoading(false);
                history.push('/superadmin/plantillas');
            });
    };
    
    const agregarSeccion = () => {
        const nuevaSeccion = {
            id: `seccion_${Date.now()}`,
            titulo: `Sección ${secciones.length + 1}`,
            campos: []
        };
        setSecciones([...secciones, nuevaSeccion]);
    };
    
    const eliminarSeccion = (index) => {
        if (secciones.length === 1) {
            alert('Debe haber al menos una sección');
            return;
        }
        const nuevasSecciones = secciones.filter((_, i) => i !== index);
        setSecciones(nuevasSecciones);
    };
    
    const actualizarTituloSeccion = (index, nuevoTitulo) => {
        const nuevasSecciones = [...secciones];
        nuevasSecciones[index].titulo = nuevoTitulo;
        setSecciones(nuevasSecciones);
    };
    
    const agregarCampo = (seccionIndex) => {
        const nuevoCampo = {
            id: `campo_${Date.now()}`,
            label: 'Nuevo Campo',
            tipo: 'text',
            requerido: false,
            valor: ''
        };
        
        const nuevasSecciones = [...secciones];
        nuevasSecciones[seccionIndex].campos.push(nuevoCampo);
        setSecciones(nuevasSecciones);
    };
    
    const eliminarCampo = (seccionIndex, campoIndex) => {
        const nuevasSecciones = [...secciones];
        nuevasSecciones[seccionIndex].campos = nuevasSecciones[seccionIndex].campos.filter((_, i) => i !== campoIndex);
        setSecciones(nuevasSecciones);
    };
    
    const actualizarCampo = (seccionIndex, campoIndex, propiedad, valor) => {
        const nuevasSecciones = [...secciones];
        nuevasSecciones[seccionIndex].campos[campoIndex][propiedad] = valor;
        setSecciones(nuevasSecciones);
    };
    
    const guardarPlantilla = (e) => {
        e.preventDefault();
        
        if (!nombre.trim()) {
            alert('Por favor ingrese el nombre de la plantilla');
            return;
        }
        
        if (secciones.length === 0) {
            alert('Debe haber al menos una sección');
            return;
        }
        
        for (let i = 0; i < secciones.length; i++) {
            if (secciones[i].campos.length === 0) {
                alert(`La sección "${secciones[i].titulo}" debe tener al menos un campo`);
                return;
            }
        }
        
        setSubmitting(true);
        
        const estructuraJSON = {
            metadata: {
                tipo_plantilla: especialidad || 'general',
                version: '1.0'
            },
            secciones: secciones
        };
        
        const data = {
            nombre: nombre,
            descripcion: descripcion,
            especialidad: especialidad,
            estado: estado,
            estructura: estructuraJSON
        };
        
        axios.put(`/superadmin/plantillas-admin/${id}`, data)
            .then(response => {
                setSubmitting(false);
                alert('Plantilla actualizada exitosamente');
                history.push('/superadmin/plantillas');
            })
            .catch(error => {
                setSubmitting(false);
                console.error(error);
                alert('Error al guardar plantilla: ' + (error.response?.data?.message || 'Error desconocido'));
            });
    };

    if (loading) {
        return (
            <div className="loading-container">
                <div className="spinner-border text-info" role="status">
                    <span className="sr-only">Cargando...</span>
                </div>
            </div>
        );
    }

    return (
        <SuperadminLayout>
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h4>
                    <i className="fas fa-file-medical"></i> Editar Plantilla
                </h4>
                <Link to="/superadmin/plantillas" className="btn btn-secondary">
                    <i className="fas fa-arrow-left"></i> Volver
                </Link>
            </div>

            <form onSubmit={guardarPlantilla}>
                <div className="form-section">
                    <h5>Información Básica</h5>
                    
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Nombre de la Plantilla <span className="text-danger">*</span></label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={nombre}
                                    onChange={(e) => setNombre(e.target.value)}
                                    placeholder="Ej: Medicina General, Odontología, etc."
                                    required
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Especialidad</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={especialidad}
                                    onChange={(e) => setEspecialidad(e.target.value)}
                                    placeholder="Ej: Medicina General, Odontología"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-9">
                            <div className="form-group">
                                <label>Descripción</label>
                                <textarea
                                    className="form-control"
                                    rows="2"
                                    value={descripcion}
                                    onChange={(e) => setDescripcion(e.target.value)}
                                    placeholder="Descripción opcional de la plantilla"
                                />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="form-group">
                                <label>Estado</label>
                                <select
                                    className="form-control"
                                    value={estado}
                                    onChange={(e) => setEstado(parseInt(e.target.value))}
                                >
                                    <option value={1}>Activa</option>
                                    <option value={0}>Inactiva</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                {secciones.map((seccion, seccionIndex) => (
                    <div key={seccionIndex} className="form-section">
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <input
                                    type="text"
                                    className="form-control"
                                    value={seccion.titulo}
                                    onChange={(e) => actualizarTituloSeccion(seccionIndex, e.target.value)}
                                    placeholder="Título de la sección"
                                />
                            </div>
                            <div className="col-md-6 text-right">
                                <button
                                    type="button"
                                    className="btn btn-sm btn-info mr-2"
                                    onClick={() => agregarCampo(seccionIndex)}
                                >
                                    <i className="fas fa-plus"></i> Agregar Campo
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-sm btn-outline-danger"
                                    onClick={() => eliminarSeccion(seccionIndex)}
                                >
                                    <i className="fas fa-trash"></i> Eliminar Sección
                                </button>
                            </div>
                        </div>
                        
                        {seccion.campos.length === 0 && (
                            <div className="alert alert-info">
                                <i className="fas fa-info-circle"></i> No hay campos en esta sección. 
                                Haga clic en "Agregar Campo" para añadir uno.
                            </div>
                        )}
                        
                        {seccion.campos.map((campo, campoIndex) => (
                            <div key={campoIndex} className="card mb-2">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Etiqueta del Campo</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={campo.label}
                                                    onChange={(e) => actualizarCampo(seccionIndex, campoIndex, 'label', e.target.value)}
                                                    placeholder="Ej: Motivo de Consulta"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label>ID del Campo</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={campo.id}
                                                    onChange={(e) => {
                                                        const nuevoId = e.target.value.replace(/\s+/g, '_').toLowerCase();
                                                        actualizarCampo(seccionIndex, campoIndex, 'id', nuevoId);
                                                    }}
                                                    placeholder="Ej: peso, altura"
                                                />
                                                <small className="form-text text-muted">Sin espacios. Usar en fórmulas: {'{'}id{'}'}</small>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Tipo de Campo</label>
                                                <select
                                                    className="form-control"
                                                    value={campo.tipo}
                                                    onChange={(e) => actualizarCampo(seccionIndex, campoIndex, 'tipo', e.target.value)}
                                                >
                                                    <option value="text">Texto</option>
                                                    <option value="textarea">Texto Largo</option>
                                                    <option value="select">Lista Desplegable</option>
                                                    <option value="number">Número</option>
                                                    <option value="checkbox">Casilla</option>
                                                    <option value="date">Fecha</option>
                                                    <option value="formula">Fórmula</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Opciones</label>
                                                <div className="form-check">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        checked={campo.requerido || false}
                                                        onChange={(e) => actualizarCampo(seccionIndex, campoIndex, 'requerido', e.target.checked)}
                                                        id={`req_${seccionIndex}_${campoIndex}`}
                                                    />
                                                    <label className="form-check-label" htmlFor={`req_${seccionIndex}_${campoIndex}`}>
                                                        Requerido
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-2 text-right">
                                            <label>&nbsp;</label>
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-outline-danger btn-block"
                                                onClick={() => eliminarCampo(seccionIndex, campoIndex)}
                                            >
                                                <i className="fas fa-trash"></i> Eliminar
                                            </button>
                                        </div>
                                    </div>
                                    
                                    {campo.tipo === 'select' && (
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Opciones (separadas por coma)</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        defaultValue={campo.opciones ? campo.opciones.join(', ') : ''}
                                                        onBlur={(e) => {
                                                            const opciones = e.target.value.split(',').map(o => o.trim()).filter(o => o);
                                                            actualizarCampo(seccionIndex, campoIndex, 'opciones', opciones);
                                                        }}
                                                        placeholder="Ej: Si, No, No Aplica"
                                                    />
                                                    <small className="form-text text-muted">
                                                        Separe las opciones con comas. Ejemplo: Opción 1, Opción 2, Opción 3
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    
                                    {campo.tipo === 'formula' && (
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Expresión de Fórmula</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={campo.formula || ''}
                                                        onChange={(e) => actualizarCampo(seccionIndex, campoIndex, 'formula', e.target.value)}
                                                        placeholder="Ej: {peso} / ({altura} * {altura})"
                                                    />
                                                    <small className="form-text text-muted">
                                                        Use <code>{'{id_campo}'}</code> para referenciar otros campos. Ejemplo: <code>{'{peso} / ({altura} * {altura})'}</code>
                                                    </small>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Decimales</label>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        value={campo.decimales ?? 2}
                                                        onChange={(e) => actualizarCampo(seccionIndex, campoIndex, 'decimales', parseInt(e.target.value) || 2)}
                                                        min="0"
                                                        max="10"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Unidad de Medida</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={campo.unidad || ''}
                                                        onChange={(e) => actualizarCampo(seccionIndex, campoIndex, 'unidad', e.target.value)}
                                                        placeholder="Ej: kg/m², ml, %"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                ))}
                
                <button type="button" className="btn btn-secondary mb-4" onClick={agregarSeccion}>
                    <i className="fas fa-plus"></i> Agregar Sección
                </button>

                <div className="form-group mt-4">
                    <button type="submit" className="btn btn-superadmin" disabled={submitting}>
                        {submitting ? (
                            <>
                                <span className="spinner-border spinner-border-sm mr-2"></span>
                                Guardando...
                            </>
                        ) : (
                            <>
                                <i className="fas fa-save"></i> Actualizar Plantilla
                            </>
                        )}
                    </button>
                    <Link to="/superadmin/plantillas" className="btn btn-secondary ml-2">
                        Cancelar
                    </Link>
                </div>
            </form>
        </SuperadminLayout>
    );
};

export default EditarPlantillaAdmin;
